// extracted by mini-css-extract-plugin
export default {"main":"Main_main__fNCqd","main__empty":"Main_main__empty__uO0QI","main__container":"Main_main__container__MObV5"};